import type { Entity } from 'src/lib/collection';
import type { PlatformGraphQLError } from 'src/lib/graphql';

export const JOB_STATUS = {
  created: 'created',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
} as const;
export type JobStatus = (typeof JOB_STATUS)[keyof typeof JOB_STATUS];

export const JOB_ERROR_CODE = {
  generalError: 'general_error',
} as const;
export type JobErrorCode = (typeof JOB_ERROR_CODE)[keyof typeof JOB_ERROR_CODE];

export interface Job extends Entity {
  status: JobStatus;
  processingErrors: PlatformGraphQLError[];
  result?: unknown;
  step?: number;
}
